import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionFooterBannerComponent } from './section-footer-banner.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [SectionFooterBannerComponent],
  imports: [CommonModule, ButtonModule],
  exports: [SectionFooterBannerComponent],
})
export class SectionFooterBannerModule {}
